import React, { useState, useEffect } from "react";
import TextArea from "../ReusableComponents/TextArea";
import InputText from "../ReusableComponents/InputText";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import DropDown from "../ReusableComponents/DropDown";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import GridPageWithCheckBox from "../components/GridPageWithCheckBox";
import { mainTable } from "../css/Common";

import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { issueHeader, ReceiptsHeaders } from "../components/HeaderAttribute";

import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import IssuesPopup from "../popup-containers/Issuespopup";
import IssueMainPopup from "../popup-containers/IssueMainPopup";
// import { data } from "react-router-dom";
import toast from "react-hot-toast";
import PopUpButtons from "../components/PopUpButtons";
import usePrevious from "../Hook/UsePrevious";
import Loader from "../ReusableComponents/Loader";
const Issues = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [submitBtnDisabled, setsubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [issueError, setIssueError] = useState("");
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setupdateScreenTitle] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [issueData, setIssueData] = useState({});

  const [issueTableData, setIssueTableData] = useState(false);
  const [issueRecord, setIssueRecord] = useState(false);
  const [popUpViewOpen, setPopUpViewOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const createdBy = sessionStorage.getItem("createdBy");
  const [itemTypeDD, setItemTypeDD] = useState([]);
  // const clientId = sessionStorage.getItem("MstClientId");
  const clientId = sessionStorage.getItem("MstClientId");
  const [errors, setErrors] = useState({
    issueToError: "",
    roomError: "",
  });
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [roomType, setRoomType] = useState([]);
  const [room, setRoom] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);

  const [popUpData, setPopUpData] = useState({});
  const [popUpDataDD, setPopUpDataDD] = useState({});
  const [itemTypeDropdown, setItemTypeDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [itemNameDropdown, setItemNameDropdown] = useState([]);

  const [formFields, setFormFields] = useState({
    issueNo: "ISS",
    issueDate: new Date().toISOString().split("T")[0],
    issueTo: "",
    room: "",
    remarks: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    issueNoError: "",
    issueDateError: "",
    issueToError: "",
    roomError: "",
    remarksError: "",
  });

  const [MstIssueId, setMstIssueId] = useState("");

  const [commoditiesDetails, setCommoditiesDetails] = useState("");
  const [tableData, setTableData] = useState([
    {
      itemType: "",
      itemCategoryId: "",
      itemId: "",
      quantity: "",
      uom: "",
      rate: "",
      itemList: [], // filtered item list per row
      itemCategoryList: [],
    },
  ]);
  const [issueChildData, setIssueChildData] = useState([]);
  useEffect(() => {
    BindIssue();
  }, []);

  const BindIssue = async () => {
    try {
      setIsLoading(true);

      const requestData = {
        mstClientId: clientId,
      };
      const response = await BindPostAPI(requestData, "IssueAPI/BindIssue");
      console.log(response, "issue fiull data");
      if (response && response.data) {
        const data = response.data;

        // Grid data
        // 1. Get original table
        const issueTable = data?.Table || [];

        // 2. Get Room and RoomType lookup tables
        const roomList = data?.Table4 || [];
        const roomTypeList = data?.Table5 || [];

        // 3. Enrich each row in issueTable with readable names and S.No
        const enrichedIssues = issueTable.map((item, index) => {
          const roomName =
            roomList.find((r) => r.MstRoomMasterID === item.Room)?.RoomName ||
            "";
          const roomType =
            roomTypeList.find((rt) => rt.MstRoomTypeId === item.IssueTo)
              ?.RoomType || "";

          return {
            ...item,
            sno: index + 1, // 👈 for S.No column
            RoomName: roomName, // 👈 for Room column
            RoomType: roomType, // 👈 for Issue To column
          };
        });

        // 4. Set to state
        setBindIssueDataGrid(data?.Table7 || []);
        setBindIssueData(issueTable);
        console.log("IssueTable:", issueTable);
        const mappedRooms = (data?.Table4 || []).map((item) => ({
          value: item.MstRoomMasterID,
          label: item.RoomName,
          typeId: item.MstRoomTypeId, // <-- must exist in data
        }));
        setRoom(mappedRooms);
        const RoomType = (data?.Table5 || []).map((item) => ({
          value: item.MstRoomTypeId,
          label: item.RoomType,
        }));
        setRoomType(RoomType);

        // Dropdowns
        const itemTypeOptions = (data?.Table1 || []).map((item) => ({
          value: item.MstItemTypeId,
          label: item.ItemType,
        }));

        // setItemTypeDD(itemTypeOptions)
        //setItemTypeDropdown(itemTypeOptions);
        setItemTypeDropdown(itemTypeOptions);

        const categoryOptions = (data?.Table2 || []).map((item) => ({
          value: item.MstItemCategoryId,
          label: item.ItemCategory,
        }));
        setCategoryDropdown(data.Table2 || []);

        const itemNameOptions = (data?.Table3 || []).map((item) => ({
          value: item.MstItemId,
          label: item.ItemName,
        }));
        setItemNameDropdown(data?.Table3);
        setIssueChildData(response.data.Table6);
        setBindissueChildData(response.data.Table6);
      } else {
        console.error("BindIssue: Invalid response", response);
      }
    } catch (error) {
      console.error("BindIssue Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    
    const selectedType = formFields.issueTo;

    // if no type selected, show empty or all rooms depending on UX
    if (!selectedType) {
      setFilteredRooms([]); // or setFilteredRooms(room) to show all
      // also clear selected room if any
      if (formFields.room) {
        setFormFields((prev) => ({ ...prev, room: null }));
      }
      return;
    }

    // ensure type comparison is consistent (string/number)
    const filtered = room.filter(
      (r) => String(r.typeId) == String(selectedType)
    );

    setFilteredRooms(filtered);

    // if current selected room is not in filtered list, clear it
    if (formFields.room && !filtered.some((r) => r.value === formFields.room)) {
      setFormFields((prev) => ({ ...prev, room: null }));
    }
  }, [formFields.issueTo, room]);

  const [bindIssueData, setBindIssueData] = useState([]);
  const [bindIssueDataGrid, setBindIssueDataGrid] = useState([]);

  const handleEdit = (rowIndex) => {
    setupdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setMstIssueId(bindIssueData[rowIndex].MstIssueId);
    setFormFields({
      ...formFields,
      mstIssueId: bindIssueData[rowIndex].TxnIssueId,
      issueNo: bindIssueData[rowIndex].IssueNo,
      issueDate: bindIssueData[rowIndex].IssueDate.split("T")[0],
      issueTo: bindIssueData[rowIndex].IssuedTo,
      room: bindIssueData[rowIndex].Room,
      remarks: bindIssueData[rowIndex].Remarks,
    });

    const TestTxnIssueId = bindIssueData[rowIndex].TxnIssueId;

    if (!TestTxnIssueId) {
      console.error("TxnIssueId not found");
      return;
    }

    const filtered = bindissueChildData.filter(
      (item1) => item1?.TxnIssueId === TestTxnIssueId
    );

    if (filtered.length === 0) {
      setTableData([
        {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          uom: "",
          quantity: "",
          rate: "",
          itemCategoryList: [],
          itemList: [],
        },
      ]);
    } else {
      // Append the filtered data to your state using appendDataToState function
      appendDataToConsumeTable(JSON.stringify(filtered));
    }
  };

  const appendDataToConsumeTable = (newDataString) => {
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        itemType: data.MstItemTypeId,
        itemCategoryId: data.MstCategoryId,
        itemId: data.MstNameId,
        rate: data.Rate.toString(),
        uom: data.UOM,
        quantity: data.Quantity.toString(),
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    updateTableData1(formattedDataArray);
    convertArrayToJSONString(formattedDataArray);
  };
  const [bindissueChildData, setBindissueChildData] = useState([]);
  const showAdd = () => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setupdateScreenTitle(false);
    setVisibleAdd(true);
  };

  const handleIssue = (rowIndex, flag) => {
    handleOpen(true);
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }
    setIssueData(bindIssueData[rowIndex]);
    setFormFields({
      ...formFields,
      mstIssueId: bindIssueData[rowIndex].MstIssueId,
    });
    const rowData = bindIssueData[rowIndex];

    setPopUpData(rowData);
    const TesttxnIssueId = bindIssueData[rowIndex].TxnIssueId;

    // Step 1: Filter data for this enquiry
    const filtered = bindissueChildData.filter(
      (item) => item && String(item.TxnIssueId) === String(TesttxnIssueId)
    );
    setPopUpDataDD(filtered);
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  const handleFieldsChange = (value, name) => {
    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  const showView = (rowIndex, flag) => {
    setPopUpViewOpen(true);
    const rowdata = bindIssueData[rowIndex];
    //setmainconsumeRecord(rowdata);
    setIssueRecord(rowdata);

    const TesttxnIssueId = bindIssueData[rowIndex].TxnIssueId;

    // Step 1: Filter data for this enquiry
    const filtered = issueChildData.filter(
      (item) => item && String(item.TxnIssueId) === String(TesttxnIssueId)
    );

    setIssueTableData(filtered);
  };

  const cancel = () => {
    BindIssue();
    setVisibleAdd(false);
    setIssueError("");
    setsubmitBtnDisabled(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setupdateScreenTitle(false);
    setIsLoading(false);
    setpopUpOpen(false);
    setPopUpViewOpen(false);
    setFormFields({
      issueNo: "ISS",
      issueDate: new Date().toISOString().split("T")[0],
      issueTo: "",
      room: "",
      remarks: "",
    });

    setFormFieldsError({});
    setErrors({
      issueToError: "",
      roomError: "",
    });
    setTableData([
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
    setIsLoading(false);
    setsubmitBtnDisabled(false);
    setIsOpen(false);

    console.log("Form cancelled and reset");
  };

  const handleInputChangeForm = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setCommoditiesDetails(jsonString);
      console.log("data", tableData);

      console.log("JsonString", jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const newErrors = { ...errors };
    if (!value) {
      newErrors[name] = "This field is required";
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
  };

  const handleDeleteRow = (index) => {
    if (tableData.length != 1) {
      const newTableData = [...tableData];
      newTableData.splice(index, 1);
      setTableData(newTableData);
    } else {
      setTableData([
        {
          itemType: "",
          itemCategoryId: "",
          itemId: "",
          quantity: "",
          uom: "",
          rate: "",
          itemList: [], // filtered item list per row
          itemCategoryList: [],
        },
      ]);
    }
  };

  const handleInputChangeTable = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
      convertArrayToJSONString(updatedData);
      return updatedData;
    });
  };
  const handleAddRow = () => {
    if (tableData.length >= 4) {
      toast.error("Cannot add more than 4 rows.");
      return;
    }

    // Get the last row's itemCategoryId and itemName (if applicable)
    const lastRow = tableData[tableData.length - 1];

    // Check if the last row has both itemCategoryId and itemName selected
    if (lastRow && lastRow.itemCategoryId && lastRow.itemId) {
      // Check for duplicates in tableData
      const isDuplicate = tableData.some(
        (row, index) =>
          index !== tableData.length - 1 && // Exclude the last row itself
          row.itemCategoryId === lastRow.itemCategoryId &&
          row.itemName === lastRow.itemId
      );

      if (isDuplicate) {
        toast.error("Item with the same category and name already exists.");
        return;
      }
    } else {
      // Optionally, you can add a check to ensure itemCategoryId and itemName are selected
      toast.error(
        "Please select both Item Category and Item Name before adding a new row."
      );
      return;
    }

    // Add new row if validation passes
    setTableData([
      ...tableData,
      {
        itemType: "",
        itemCategoryId: "",
        itemId: "",
        quantity: "",
        rate: "",
        uom: "",
        itemCategoryList: [],
        itemList: [],
      },
    ]);
  };

  const handleSubmit = async (items, flag) => {

    try {
      setsubmitBtnDisabled(true);
      setIsLoading(true);

      if (flag === 1 || flag === 2) {
        // ✅ Validation
        const newErrors = {
          issueToError: formFields.issueTo ? "" : "Select Issue To",
          roomError: formFields.room ? "" : "Select Room",
        };

        setErrors(newErrors);

        if (commoditiesDetails.trim() === "") {
          setIssueError("Fill the above table");
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        }

        let issueData;
        try {
          issueData = JSON.parse(commoditiesDetails);
        } catch (error) {
          console.error("Error parsing Issue data:", error);
          setIssueError("Error parsing Issue data");
          return;
        }

        if (!Array.isArray(issueData)) {
          console.error("Issue data is not an array");
          setIssueError("Issue data is not an array");
          return;
        }

        // ✅ Child row validations
        const issueErrors = issueData.map((receipt, index) => {
          if (!receipt) return `Issue at index ${index + 1} is missing.`;
          if (!receipt.itemType)
            return `Issue at row ${index + 1} is missing Item Type.`;
          if (!receipt.itemCategoryId)
            return `Issue at row ${index + 1} is missing Category.`;
          if (!receipt.itemId)
            return `Issue at row ${index + 1} is missing Name.`; // ✅ FIXED
          if (!receipt.quantity)
            return `Issue at row ${index + 1} is missing Quantity.`;
          if (!receipt.rate)
            return `Issue at row ${index + 1} is missing Rate.`;
          return null;
        });

        const filteredErrors = issueErrors.filter((error) => error !== null);
        if (filteredErrors.length > 0) {
          setIssueError(filteredErrors.join("; "));
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          return;
        } else {
          setIssueError("");
        }

        const isFormValid = Object.values(newErrors).every((err) => err === "");
        if (!isFormValid) {
          setsubmitBtnDisabled(false);
          setIsLoading(false);
          toast.error("Please enter all mandatory fields.");
          return;
        }

        // ✅ Prepare payload
        const payload = {
          mstClientId: clientId,
          txnIssueId: parseInt(formFields.mstIssueId || 0),
          issueNo: formFields.issueNo.toString(),
          issueDate: formFields.issueDate
            ? new Date(formFields.issueDate).toISOString()
            : null,
          issuedTo: parseInt(formFields.issueTo),
          room: parseInt(formFields.room),
          remarks: formFields.remarks,
          createdBy: parseInt(createdBy),
          flag,
          issue: JSON.stringify(
            tableData.map((row) => ({
              itemType: row.itemType,
              itemCategoryId: row.itemCategoryId,
              itemId: row.itemId, // ✅ FIXED (was row.itemName before)
              quantity: row.quantity,
              uomId: row.uom || "",
              rate: row.rate,
            }))
          ),
        };

        console.log("Final Payload:", payload);

        try {
          const response = await IUDAPI(payload, "IssueAPI/IUDIssue");
          console.log(response, "test response issues");
          const result = response?.data?.Table?.[0]?.Result;

          if (flag === 1 && result === "S") {
            toast.success("Issue Added Successfully 👍");
            setTimeout(cancel, 1000);
          } else if (flag === 2 && result === "M") {
            toast.success("Issue Updated Successfully 👍");
            setTimeout(cancel, 1000);
          } else {
            toast.error("Please fill the Child table.");
          }
        } catch (error) {
          console.error("API Error:", error.response?.data || error.message);
          toast.error("Something went wrong. Check console for details.");
        }
      }

      // ✅ DELETE HANDLING
      if (flag === 3) {
        try {
          const data = {
            txnIssueId: formFields.mstIssueId,
            createdby: parseInt(createdBy),
            flag,
          };

          const response = await IUDAPI(data, "IssueAPI/IUDIssue");
          const result = response?.data?.Table?.[0]?.Result;

          if (result === "D") {
            toast.success("Issue Deleted Successfully 🗑️");
            setTimeout(cancel, 1000);
          } else {
            toast.error("Delete failed. Please try again.");
          }
        } catch (error) {
          console.error(
            "Delete API Error:",
            error.response?.data || error.message
          );
          toast.error("Something went wrong while deleting.");
        } finally {
          setIsLoading(false);
          setsubmitBtnDisabled(false);
        }
      }
    } catch (err) {
      console.error("Unexpected Error:", err);
      toast.error("Unexpected error occurred.");
      setIsLoading(false);
      setsubmitBtnDisabled(false);
    }
  };

  const previousTableData = usePrevious(tableData);
  useEffect(() => {
    updateTableData();
  }, [tableData]);

  const updateTableData = async () => {

    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData);
      console.log("itemcategory", categoryDropdown);

      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
          console.log(row.itemCategoryList);
        }
        // Update itemList and uom if itemcategory is selected
        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown

            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          console.log(row.itemList);

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemId
          );
          row.uom = selectedItem?.uom || "";
        }
        if (row?.itemId && !updateScreenTitle) {
          const data = {
            mstClientId: parseInt(clientId || 0),
            mstItemTypeId: parseInt(row.itemType || 0),
            mstCategoryId: parseInt(row.itemCategoryId || 0),
            mstNameId: parseInt(row.itemId || 0),
          };

          try {
            const response = await BindPostAPI(data, "IssueAPI/BindIssueStock");

            const balanceQuantity =
              response?.data?.Table?.[0]?.RemainingQuantity || "";
            row.currentStock =
              balanceQuantity > row.currentQty
                ? 0
                : row.currentQty - balanceQuantity;
            row.currentStock = balanceQuantity;
            console.log("balanceQuantity", balanceQuantity);
          } catch (error) {
            console.error("Error fetching current stock:", error);
            row.currentStock = ""; // Reset on error
          }
        }
      }

      setTableData(updatedTableData);
    }
  };

  const updateTableData1 = async () => {
    if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
      const updatedTableData = [...tableData];
      console.log(updateTableData);
      console.log("itemcategory", categoryDropdown);

      for (const row of updatedTableData) {
        // Update itemCategoryList if itemtype is selected
        if (row?.itemType) {
          const filteredCategories = categoryDropdown
            .filter((item) => item.MstItemTypeId === row.itemType)
            .map((item) => ({
              value: item.MstItemCategoryId,
              label: item.ItemCategory,
            }));
          row.itemCategoryList = filteredCategories;
          console.log(row.itemCategoryList);
        }

        // Update itemList and uom if itemcategory is selected
        if (row?.itemCategoryId) {
          const filteredItems = itemNameDropdown

            .filter((item) => item.MstItemCategoryId === row.itemCategoryId)
            .map((item) => ({
              value: item.MstItemId,
              label: item.ItemName,
              uom: item.UOM,
            }));
          row.itemList = filteredItems;
          console.log(row.itemList);

          const selectedItem = filteredItems.find(
            (item) => item.value === row.itemName
          );
          row.uom = selectedItem?.uom || "";
        }
      }

      setTableData(updatedTableData);
    }
  };

  // console.log(tableData);

  const handlePopup = (rowIndex, flag) => {
    setpopUpOpen(true);
    setRoomType(rowIndex);
  };

  // Empty dependency array means this effect runs once when the component mounts

  return (
    <MainLayout pageName={"3"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Issues"
          header={issueHeader}
          records={bindIssueDataGrid}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleIssue}
          showAdd={showAdd}
          onLaundryIssueView={showView}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              title="Issues"
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />
          </div>

          <div className="grid gap-4 mb-10 md:grid-cols-4">
            <InputText
              title="Issue No"
              name="issueNo"
              placeholder="ISS-2025-000001"
              content={formFields.issueNo}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              errorMessage={errors.issueNo}
              classStar="text-red-500"
              disabled={true}
            />

            <InputText
              inputType="date"
              title="Issue  Date"
              name="issueDate"
              classStar="text-red-500"
              maxLength={100}
              content={formFields.issueDate}
              controlFunc={handleInputChangeForm}
              controlFuncBlur={handleBlur}
              disabled={false}
              inputClassName="w-full"
              errorMessage={errors.issueDate}
            />
            <AutoDropDown
              name="issueTo"
              title="Room Type"
              selectedOption={roomType.find(
                (x) => x.value === formFields.issueTo
              )}
              classStar="text-red-500"
              options={roomType}
              placeholder="Select Room Type"
              Class="custom-class"
              disabled={false}
              controlFunc={(e) => {

                setFormFields({
                  ...formFields,
                  issueTo: e.value,
                });
              }}
              controlFuncBlur={(e) => {
                const value = formFields.issueTo;
                setErrors((prev) => ({
                  ...prev,
                  issueToError: value ? "" : "Select Room Type",
                }));
              }}
              errorMessage={errors.issueToError}
            />
            <AutoDropDown
              name="room"
              title="Issue To"
              selectedOption={filteredRooms.find((x) => x.value === formFields.room)}
              classStar="text-red-500"

              options={filteredRooms}
              placeholder="Select Room"
              Class="custom-class"
              disabled={false}
              controlFunc={(e) => {
                setFormFields({
                  ...formFields,
                  room: e.value,
                });
              }}
              controlFuncBlur={(e) => {

                const value = formFields.room;
                setErrors((prev) => ({
                  ...prev,
                  roomError: value ? "" : "Select Room",
                }));
              }}
              errorMessage={errors.roomError}
            />
          </div>

          <div className="shadow-md p-4 rounded-md bg-white overflow-y-auto h-96">
            <form onSubmit={handleSubmit}>
              <table className="min-w-full table-auto border border-gray-300">
                <thead className="bg-[#3D6643] text-white sticky top-0 z-10 ">
                  <tr>
                    <th className="border px-2 py-2 w-[30px]">SN</th>
                    <th className="border px-4 py-2 w-[230px]">Item Type</th>
                    <th className="border px-4 py-2 w-[230px]">Category</th>
                    <th className="border px-4 py-2 w-[230px]">Name</th>
                    <th className="border px-4 py-2 w-[100px]">Quantity</th>
                    <th className="border px-4 py-2 w-[100px]">U.O.M</th>
                    <th className="border px-4 py-2 w-[100px]">Rate</th>
                    <th className="border px-4 py-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-2">{index + 1}</td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemType"
                          Class="custom-class"
                          options={itemTypeDropdown}
                          selectedOption={
                            row.itemType
                              ? itemTypeDropdown.find(
                                (x) => x.value === row.itemType
                              )
                              : ""
                          }
                          controlFunc={(e) =>
                            handleInputChange(e, index, "itemType", true)
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemCategoryId"
                          Class="custom-class"
                          options={row.itemCategoryList || []}
                          content={row.itemCategoryId}
                          selectedOption={
                            row.itemCategoryId
                              ? row.itemCategoryList?.find(
                                (x) => x.value === row.itemCategoryId
                              )
                              : ""
                          }
                          controlFunc={(e) =>
                            handleInputChange(e, index, "itemCategoryId", true)
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <AutoDropDown
                          name="itemId"
                          Class="custom-class"
                          options={row.itemList || []}
                          content={row.itemId}
                          selectedOption={
                            row.itemId
                              ? row.itemList?.find((x) => x.value == row.itemId)
                              : ""
                          }
                          //content={row.itemName}
                          controlFunc={(e) =>
                            handleInputChange(e, index, "itemId", true)
                          }
                        />
                      </td>

                      <td className="border px-4 py-2">
                        <div title={`Max Stock: ${row.currentStock || 0}`}>
                          <InputText
                            type="number"
                            name="quantity"
                            value={row.quantity}
                            content={row.quantity}
                            controlFunc={(e) => {
                              const inputValue = e.target.value;

                              // Allow only numbers
                              if (!/^\d*$/.test(inputValue)) return;

                              // Do not allow more than currentStock
                              if (
                                parseInt(inputValue || 0) >
                                (row.currentStock || 0)
                              )
                                return;

                              // Update if valid
                              handleInputChangeTable(
                                e.target,
                                index,
                                "quantity"
                              );
                            }}
                            controlFuncBlur={(e) => {
                              const inputValue = parseInt(e.target.value || 0);

                              // If empty, zero, or greater than stock → clear value
                              if (
                                !inputValue ||
                                inputValue > (row.currentStock || 0)
                              ) {
                                handleInputChangeTable(
                                  { value: "" },
                                  index,
                                  "quantity"
                                );
                              }
                            }}
                          />
                        </div>
                      </td>

                      <td className="border px-4 py-2">
                        <InputText
                          type="text"
                          name="uom"
                          value={row.uom}
                          disabled={true}
                          content={row.uom}
                          controlFunc={(e) =>
                            handleInputChange(e, index, "uom")
                          }
                        />
                      </td>
                      <td className="border px-4 py-2">
                        {/* <InputText
                          type="number"
                          name="rate"
                          value={row.rate}
                          content={row.rate}
                          controlFunc={(e) => {
                            const InputText = e.target.value;

                            if (/^\d+$/.test(InputText)) {
                              handleInputChange(e.target, index, "rate");
                            }
                          }}
                        /> */}
                        <InputText
                          type="number"
                          name="rate"
                          value={row.rate}
                          content={row.rate}
                          controlFunc={(e) => {
                            const value = e.target.value;

                            // allow clearing OR numeric input
                            if (value === "" || /^\d+$/.test(value)) {
                              handleInputChange(
                                { value },
                                index,
                                "rate"
                              );
                            }
                          }}
                        />
                      </td>
                      {/* </tr>
                      ))} */}

                      <td className="border px-4 py-2">
                        <div className="flex gap-4 items-center justify-center">
                          <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-6 h-6 text-black cursor-pointer"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                          </svg>
                          {index === tableData.length - 1 &&
                            tableData.length < 4 && (
                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={handleAddRow}
                                className="w-6 h-6 text-black cursor-pointer"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="hidden md:block">
                {issueError && (
                  <div className="text-red-500 text-sm font-medium">
                    {issueError}
                  </div>
                )}
              </div>
              <div className="md:col-span-3"></div>
              <TextArea
                title="Remarks"
                name="remarks"
                placeholder="Remarks"
                rows={3}
                maxLength={500}
                // tabIndex="1"
                content={formFields.remarks}
                controlFunc={handleInputChangeForm}
              />

              <div className="flex justify-center mt-6 gap-4">
                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  viewSaveButton={false}
                  handleSubmit={handleSubmit}
                  disabledBtn={submitBtnDisabled}
                  cancel={cancel}
                />
              </div>
            </form>
          </div>
        </div>
      )}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handlePopup}
      >
        <div>
          <PopUpScreenTitle
            title="Issue"
            setpopUpOpen={setpopUpOpen}
            // hederDetails={true}
            viewDetails={viewDetails}
          />
          <IssueMainPopup data={popUpData} data1={popUpDataDD} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
      </MainPopup>
      <MainPopup
        popUpOpen={popUpViewOpen}
        setpopUpOpen={setPopUpViewOpen}
        Open={showView}
      >
        <div>
          <PopUpScreenTitle
            title="Issues"
            setpopUpOpen={setPopUpViewOpen}
            viewDetails={popUpViewOpen}
          />
          <IssuesPopup
            data={issueRecord}
            data1={issueTableData}
            roomType={roomType}
            room={room}
          />
        </div>
        <PopUpButtons cancel={cancel} />
      </MainPopup>
    </MainLayout>
  );
};
export default Issues;
